export default __webpack_public_path__ + "static/media/empty-betslip.67a857f5.png";